import React from 'react';
import Link from 'next/link';

import { Typography } from 'lighthouse';

import { brandLanding, servicePage } from '@/constants/routes';

import { TitleBlockProps } from './models';

import { ArrowLeft2 } from 'iconsax-react';

export const TitleBlock = ({ title, brand, category }: TitleBlockProps) => {
    return (
        <div>
            <nav aria-label='دسته‌بندی محصول' className='mb-2 flex flex-wrap items-center gap-1'>
                <Link href={`${brandLanding}/${brand.slug}`} className='hover:underline'>
                    <Typography variant='caption' color='primary' component='span'>
                        {brand.name}
                    </Typography>
                </Link>
                <ArrowLeft2 size={14} color='currentcolor' className='text-blackLowEmphasis' />
                <Link href={`${servicePage}/${category.slug}`} className='hover:underline'>
                    <Typography variant='caption' color='primary' component='span'>
                        {category.name}
                    </Typography>
                </Link>
            </nav>

            <Typography variant='h5' color='blackHighEmphasis' component='h1' className='!text-lg !leading-7 md:!text-xl md:!leading-8'>
                {title}
            </Typography>

            <hr className='my-3 opacity-10' />
        </div>
    );
};
